// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import memberDuesPaymentEntity from './entities/member-dues-payment.json';
import memberDuesPaymentMenu from '../pages/member-dues-payment/menu.json';
import memberDuesPaymentFullForm from '../pages/member-dues-payment/forms/full.json';
import memberDuesPaymentContextForm from '../pages/member-dues-payment/forms/context.json';
import memberDuesPaymentMiniForm from '../pages/member-dues-payment/forms/mini.json';
import memberDuesPaymentLookupForm from '../pages/member-dues-payment/forms/lookup.json';
import memberDuesPaymentTableView from '../pages/member-dues-payment/views/table.json';
import memberDuesPaymentCardsView from '../pages/member-dues-payment/views/cards.json';
import memberDuesPaymentDashboardView from '../pages/member-dues-payment/views/dashboard.json';

/** Тип запису «Сплата внесків» зі сторінками пакета: меню, форми та подання з pages/member-dues-payment/. */
export const memberDuesPaymentDefinition: IRecordTypeDefinition = {
  ...memberDuesPaymentEntity,
  views: assembleViewSet({
      table: memberDuesPaymentTableView,
      cards: memberDuesPaymentCardsView,
      dashboard: memberDuesPaymentDashboardView,
  }),
  form: memberDuesPaymentFullForm,
  forms: { full: memberDuesPaymentFullForm, context: memberDuesPaymentContextForm, mini: memberDuesPaymentMiniForm, lookup: memberDuesPaymentLookupForm },
  menu: memberDuesPaymentMenu,
} as IRecordTypeDefinition;
